<template lang="pug">
v-container.px-2.pt-0.pb-0(fluid)
  component(
    v-if="!isUnderContruction"
    :is="card.card_component"
    :ref="card.card_id"
    :card="card"
    :newAddress="isNewAddress"
    v-on="$listeners"
    :field-value-error-types="fieldValueErrorTypes"
    :field-value-error-messages="fieldValueErrorMessages"
  )
  .no-data(v-else) Under Construction
</template>
<script>
import RegularCard from './Components/RegularCard'; 
import AddressFields from './Components/AddressFields';
import OptinStatus from './Components/OptinStatus';
import EmailStatus from './Components/EmailStatus';

export default {
  props: {
    card: {
      type: Object,
      default: {},
    },
    isNewAddress: {
      type: Boolean,
      default: false,
    },
    fieldValueErrorMessages: {
      type: Object,
      default: [],
    },
    fieldValueErrorTypes: {
      type: Array,
      default: {},
    },
  },
  computed: {
    isUnderContruction() {
      return this.card.card_component === "UnderContruction";
    },
  },
  components: {
    RegularCard,
    AddressFields,
    OptinStatus,
    EmailStatus,
  },
};
</script>
<style lang="scss" scoped>
.no-data {
  display: flex;
  justify-content: center;
  margin: 5px 0;
  padding: 5px 0;
  font-size: 20px;
  font-weight: 300;
  color: #757557;
}
</style>
